import React, { useState } from "react";
import { Tag, Divider, message, Popconfirm, Flex } from "antd";
import {
  CloseOutlined,
  BookOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from 'dayjs';
import { AddEducation } from "../../pages/Users/AddEducation";
import { useStore } from "../../stores/root-store-context";
import { Education } from "../../models/Education";

interface EducationItem {
  University: string;
  Degree: string;
  City: string;
  Country: string;
  StartDate: string;
  EndDate: string;
  Profession: string;
}

interface EducationBlockProps {
  educationList: EducationItem[];
  removeEducation: (item: EducationItem) => Promise<void>;
  canRemove: boolean;
  updatePage: () => void;

}

const EducationBlock: React.FC<EducationBlockProps> = ({
  educationList,
  removeEducation,
  canRemove,
  updatePage
}) => {
  const { t } = useTranslation();
  const [isModalEducation, setIsModalEducation] = useState(false);
  const { applicationStore, educationStore } = useStore();
  const [educationItem, setEducationItem] = useState<Education | undefined>();

  function ParseToJson(str: string): any[] {
    try {
      return JSON.parse(str);
    } catch (e) {
      return [];
    }
  }

  if (educationList.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #d4d4d4",
        borderRadius: "8px",
        width: "100%",
        marginBottom: "16px",
      }}
    >
      <h3 style={{ marginBottom: "20px", color: "#333" }}>
        {t("user.Education")}
      </h3>
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {educationList.map((item, index) => (
          <div
            key={index}
            style={{
              position: "relative",
              backgroundColor: "#fff",
              padding: "16px",
              borderRadius: "8px",
              border: "1px solid #d4d4d4",
              overflow: "hidden",
            }}
          >
            {canRemove && (

              <Flex align='end' justify='end' style={{ position: "absolute", top: "8px", right: "8px" }} gap={8}>
                <EditOutlined
                  style={{
                    top: "8px",
                    right: "8px",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  onClick={async () => {
                    setEducationItem(item);
                    setIsModalEducation(true);
                  }}
                />
                <Popconfirm
                  title={t("DeleteItem")}
                  okText={t("Yes")}
                  cancelText={t("No")}
                  onConfirm={async () => await removeEducation(item)}
                >
                  <CloseOutlined
                    style={{
                      top: "8px",
                      right: "8px",
                      cursor: "pointer",
                      color: "#ff4d4f",
                      fontSize: "16px",
                    }}
                  />
                </Popconfirm>

              </Flex>
            )}
            <h3
              style={{
                marginBottom: "8px",
                fontWeight: "bold",
                color: "#2a2a2a",
                fontSize: "16px",
              }}
            >
              {item.University}
            </h3>
            <div
              style={{
                marginBottom: "8px",
                color: "#4a4a4a",
                fontSize: "14px",
              }}
            >
              <BookOutlined style={{ marginRight: "8px", color: "#1890ff" }} />
              {item.Degree ? ParseToJson(item.Degree).join(', ') : ''}
            </div>
            <div
              style={{
                marginBottom: "8px",
                color: "#6c6c6c",
                fontSize: "14px",
              }}
            >
              <EnvironmentOutlined
                style={{ marginRight: "8px", color: "#52c41a" }}
              />
              {item.City}, {item.Country}
            </div>
            <div
              style={{
                color: "#8c8c8c",
                fontSize: "14px",
              }}
            >
              <CalendarOutlined
                style={{ marginRight: "8px", color: "#faad14" }}
              />
              {item.StartDate ? dayjs(item.StartDate).format("YYYY-MM-DD") : ""} - {item.EndDate ? dayjs(item.EndDate).format("YYYY-MM-DD") : ""}
            </div>
            {item.Profession && (
              <>
                <Divider style={{ margin: "12px 0", borderColor: "#e8e8e8" }} />
                <div
                  style={{
                    backgroundColor: "#e6f7ff",
                    color: "#1890ff",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 14, fontWeight: 400 }}>
                    {item.Profession}
                  </pre>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      <AddEducation isModalOpen={isModalEducation} hideModal={() => {
        setIsModalEducation(false);
        setEducationItem(undefined);
      }}
        userId={applicationStore.user.id}
        educationItem={educationItem}
        fetchEducation={() => {
          updatePage();
        }} />

    </div>
  );
};

export default EducationBlock;
